



























































































import { mapGetters } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';
import { Form, FormLabel } from '@/models/Form';
import { BDropdownItem, BDropdown } from 'bootstrap-vue';
import BaseForm from '@/components/BaseForm.vue';
import Jumbotron from '@/components/Jumbotron.vue';
import ModalFormConfig from '@/components/modals/ModalFormConfig.vue';
import ModalFormLabelRemove from '@/components/modals/ModalFormLabelRemove.vue';
import ModalFormLabelUpdate from '@/components/modals/ModalFormLabelUpdate.vue';
import ModalFormTagCreate from '@/components/modals/ModalFormLabelCreate.vue';

@Component({
    name: 'Forms',
    components: {
        'jumbotron': Jumbotron,
        'base-form': BaseForm,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'modal-form-config': ModalFormConfig,
        'modal-form-label-remove': ModalFormLabelRemove,
        'modal-form-label-update': ModalFormLabelUpdate,
        'modal-form-label-create': ModalFormTagCreate,
    },
    computed: mapGetters({
        forms: 'forms/all',
        formLabels: 'formLabels/all',
    }),
})
export default class Forms extends Vue {
    error = '';
    forms!: Form[];
    form: Form | null = null;

    formLabels!: FormLabel[];
    filters: number[] = [];

    get filteredForms() {
        if (!this.filters.length) {
            return this.forms;
        }
        return this.forms.filter((form: Form) => (form.formLabel ? this.filters.includes(form.formLabel) : false));
    }

    removeFilter(label: FormLabel) {
        const index = this.formLabels.findIndex((f) => label.id === f.id);
        const i = this.filters.indexOf(label.id);

        this.filters.splice(i, 1);

        Vue.set(this.formLabels[index], 'active', false);
    }

    addFilter(label: FormLabel) {
        const index = this.formLabels.findIndex((f) => label.id === f.id);

        this.filters.push(label.id);

        Vue.set(this.formLabels[index], 'active', true);
    }
}
